import { useAppMutation } from "../../../../http/useAppMutation.ts";
import { pushGTMUserData } from "../../../../tracking/gtm/pushGTMUserData.ts";
import { trackEvent, updateUser } from "../../../../tracking/tracking.ts";

export const useUpdateUser = (onCacheUpdated?: () => void) => {
  const mutation = useAppMutation<{
    first_name: string | null;
    last_name: string | null;
    phone_number: string | null;
    terms_and_conditions_agreement: boolean | null;
    annual_visual_content_budget: string | null;
    company_size: string | null;
    company_website: string | null;
    has_worked_recently_with_creative_agency: boolean | null;
    heard_about_us: string | null;
    industry: string | null;
    occupation: string | null;
    onboarding_finished_at: string | null;
  }>({
    path: "users/add-information",
    invalidate: ["users/me"],
    onSuccess: ({ data }) => {
      updateUser({
        first_name: data.first_name,
        last_name: data.last_name,
        phone_number: data.phone_number,
        terms_and_conditions_agreement:
          data.terms_and_conditions_agreement?.toString() ?? "false",
        annual_visual_content_budget: data.annual_visual_content_budget,
        company_size: data.company_size,
        company_website: data.company_website,
        has_worked_recently_with_creative_agency:
          data.has_worked_recently_with_creative_agency?.toString() ?? "false",
        heard_about_us: data.heard_about_us,
        industry: data.industry,
        occupation: data.occupation,
        onboarding_finished: data.onboarding_finished_at,
      });
      void (async () => {
        await pushGTMUserData({
          firstName: data.first_name,
          lastName: data.last_name,
          jobTitle: data.occupation,
          phoneNumber: data.phone_number,
        });
        trackEvent("user:update", {}, true);
      })();
    },
    onCacheUpdated: () => {
      onCacheUpdated?.();
    },
  }).mutation;
  return { updateUser: mutation.mutate, isLoading: mutation.isLoading };
};
